<template>
  <div class="created">
    <el-button type="text" size="medium" @click="$router.go(-1)">返回</el-button>
    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="分销标题" class="is-required">
        <el-col :span="24">
          <div class="toptitle training">
            <el-input v-model="ruleForm.title" placeholder="请输入分销标题" maxlength="20" show-word-limit></el-input>
          </div>
        </el-col>
      </el-form-item>
      <el-form-item label="分销时间" class="is-required">
        <el-col :span="11">
          <div class="block">
            <el-date-picker v-model="ruleForm.begin_at" type="datetime" placeholder="选择开始时间"
              @change="changeHandel"></el-date-picker>至
            <el-date-picker v-model="ruleForm.end_at" type="datetime" placeholder="选择结束时间"
              @change="changeHandel2"></el-date-picker>
          </div>
        </el-col>
      </el-form-item>
      <el-form-item label="活动图片" class="is-required">
        <el-col :span="10">
          <activityCustomUpload :formName="'activityimg'" :formValue="ruleForm.activityimg"
            @uploadSuccess="uploadSuccess" :tip="'只能上传jpg/png文件，且不超过500kb'">
          </activityCustomUpload>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button @click="resetForm('ruleForm')">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import activityCustomUpload from "@/components/activityCustomUpload.vue";
import { createUpdate, getDetail } from "@/api/distribution"
export default {
  components: { activityCustomUpload, },
  data() {
    return {
      ruleForm: {
        id: '',
        title: '',
        begin_at: '',
        end_at: '',
        activityimg: '',
      },
      id: null,
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      getDetail({ id: this.id }).then((res) => {
        // this.ruleForm = res.data
        this.ruleForm.activityimg = res.data.img_url
        this.ruleForm.title = res.data.title
        this.ruleForm.begin_at = res.data.begin_at
        this.ruleForm.end_at = res.data.end_at
        this.ruleForm.id = res.data.id
      })

    } else {
      console.log('meiyou');
    }
  },
  methods: {
    submitForm() {
      console.log(this.ruleForm);
      //检查开标题是否填写 
      if (!this.ruleForm.title) { this.$message({ message: "请输入分销标题", type: "error", }); return; }

      //检查开始时间是否填写 
      if (!this.ruleForm.begin_at) { this.$message({ message: "请填写开始时间", type: "error", }); return; }

      //检查结束时间是否填写 
      if (!this.ruleForm.end_at) { this.$message({ message: "请填写结束时间", type: "error", }); return; }

      //检查标题是否填写 
      if (!this.ruleForm.activityimg) { this.$message({ message: "请上传活动图片", type: "error", }); return; }
      // let begin_at = this.dateHandel(this.ruleForm.begin_at)
      // let end_at = this.dateHandel(this.ruleForm.end_at)

      let query = {
        id: this.ruleForm.id,
        title: this.ruleForm.title,
        img_url: this.ruleForm.activityimg,
        begin_at: this.ruleForm.begin_at,
        end_at: this.ruleForm.end_at

      }
      createUpdate(query).then((res) => {
        console.log(res);
        if (res.code) {
          this.$message({ message: "保存成功", type: "success", });
          this.$router.go(-1)
        }
      })
      console.log('xiugaihou', this.ruleForm);

    },
    changeHandel(value) {

      this.ruleForm.begin_at = this.dateHandel(value)
      console.log(this.ruleForm.begin_at, value, this.ruleForm);
    },
    changeHandel2(value) {
      this.ruleForm.end_at = this.dateHandel(value)
      console.log(this.ruleForm.end_at, value, this.ruleForm);
    },
    dateHandel(date) {


      // 使用 Date 对象的方法获取年、月、日
      let year = date.getFullYear();
      let month = date.getMonth() + 1; // 月份从 0 开始，所以要加 1
      let day = date.getDate();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();

      // 将月份和日期转换成两位数的字符串，不足两位的在前面补 0
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;

      // 将年、月、日拼接成 YYYY-MM-DD 格式的字符串
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    },
    resrvedateHandel(days) {
      let date = new Date(days);
      // 获取相应的字符串表示形式
      return date.toString();
    },
    resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.$router.go(-1)
    },
    uploadSuccess(value) {
      console.log(value);
      const fileExtension = value.fileUrl.split('.').pop().toLowerCase();
      // 判断是否是图片格式
      const isImageFormat = ['png', 'jpeg', 'jpg', 'gif', ''].includes(fileExtension);

      if (isImageFormat) {
        if (value.type == 'success') {
          const imgsize = value.file.file.sizes
          if (imgsize > 500 * 1024) {
            this.$message({
              message: '图片需小于500KB',
              type: 'error'
            });
            return
          }
        }
        this.ruleForm[value.formName] = value.fileUrl
        this.$refs.ruleForm.validateField(value.formName);
      } else {
        this.$message({
          message: '请上传图片格式文件',
          type: 'error'
        });
        return
      }

    },
  }
}
</script>

<style>
.created {
  padding: 20px;
}

.toptitle .el-input {
  width: 300px;
}
</style>